import { FileType } from '@office-start/document-types';
import { getFileTypeFromFileName } from '@office-start/file-utility';
import { useCallback } from 'react';
import { useUploadConfig } from './useUploadConfig';
/**
 *
 * @returns FileType.None if the file type is not supported by the upload service and the file type based on file extension otherwise
 */
export var useGetUploadFileType = function () {
    var _a;
    var uploadConfig = (_a = useUploadConfig()) === null || _a === void 0 ? void 0 : _a.data;
    return useCallback(function (fileName) {
        if (!uploadConfig || !fileName) {
            return FileType.None;
        }
        var fileType = fileName && getFileTypeFromFileName(fileName);
        if (!fileType || !uploadConfig.uploadFileTypes.has(fileType)) {
            return FileType.None;
        }
        return fileType;
    }, [uploadConfig]);
};
//# sourceMappingURL=useGetUploadFileType.js.map